import { ReactNode } from 'react'

import type { ColorScheme } from '@hivewatch/dark'
import { Box } from '@hivewatch/dark'

interface FilterRowIProps {
  label: string
  colorScheme: ColorScheme
  children: ReactNode
  /** Optional element rendered next to the label (e.g. an info button). */
  labelAction?: ReactNode
}

/**
 * One flat filter row: a label above a full-width selection field. Matches the
 * label treatment the dark Select renders internally, for fields
 * (MultiSelectInput) that have no label-above slot of their own.
 *
 * Shared across the dark page filter drawers — see `./FilterDrawer`.
 */
export const FilterRow = ({
  label,
  colorScheme,
  children,
  labelAction,
}: FilterRowIProps) => (
  <Box display='flex' flexDirection='column'>
    <Box alignItems='center' display='flex' gap='4px' pb='4px'>
      <Box
        as='span'
        color={colorScheme === 'light' ? 'light.text.primary' : 'text.primary'}
        textStyle='label'
      >
        {label}
      </Box>
      {labelAction}
    </Box>
    {children}
  </Box>
)
